<template>
  <div>
    <div class="spinner-cover-new" v-if="isLoading">
      <div class="spinner"></div>
    </div>
    <vue-confirm-dialog></vue-confirm-dialog>
    <div class="modal fade" id="map-model" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document" style="width: 90% !important; height: 94%">
        <div class="modal-content h-100">
          <div class="row m-0 search-box w-75">
            <div class="col-md-8 pl-1">
              <div class="card text-center shadow-sm">
                <gmap-autocomplete
                  id="map"
                  class="form-control-sm mt-1 border shadow"
                  placeholder="Adresse eingeben"
                  v-on:place_changed="autoCompletePlaceChanged"
                />
              </div>
            </div>
          </div>
          <div class="g-map-container h-100">
            <div class="switch-map border">
              <button type="button" class="btn btn-map" :class="{'bg-light shadow': map_type === 'roadmap'}" @click="map_type = 'roadmap'">
                Normal
              </button>
              <button type="button" class="btn btn-map" :class="{'bg-light shadow': map_type === 'terrain'}" @click="map_type = 'terrain'">
                Map
              </button>
              <button type="button" class="btn btn-map" :class="{'bg-light shadow': map_type === 'satellite'}" @click="map_type = 'satellite'">
                Satellite
              </button>
              <button type="button" class="btn btn-map" :class="{'bg-light shadow': map_type === 'hybrid'}" @click="map_type = 'hybrid'">
                Hybrid
              </button>
            </div>
            <GmapMap
              :center="mapCentre"
              :zoom="15"
              :mapTypeId='map_type'
              :tilt="0"
              :options="{
                zoomControl: true,
                         mapTypeControl: true,
                         scaleControl: true,
                         streetViewControl: true,
                         rotateControl: true,
                         fullscreenControl: true,
                         disableDefaultUI: false
              }"
              style="height: 100%">
              <GmapMarker
                :position="mapCentre"
                :clickable="true"
                @drag="updateCoordinates"
                @dragend="updatePointerCoordinates"
                :draggable="true">
                <gmap-info-window :opened="true">
                  <div class="card-header bg-white pt-1 pb-1 pl-0">
                    <h4>Bewegen Sie den Marker</h4>
                  </div>
                  <div class="form-group w-100 pt-1 font13rem">
                    <label class="pr-3">Geo lat : </label> <strong>{{mapLatLong.lat}}</strong>
                    <br>
                    <label class="pr-2">Geo long : </label> <strong>{{mapLatLong.lng}}</strong>
                  </div>
                </gmap-info-window>
              </GmapMarker>
            </GmapMap>
          </div>
          <!--            <span class="close-map" @click="showMaps()" ><i class="fa fa-times-circle"></i></span>-->
          <div class="s-c-btns position-absolute shadow-sm" style="left: 43%;right: auto;bottom: 17px;">
            <button @click="resetLatLng" class="btn btn-danger px-3 shadow" data-dismiss="modal" aria-label="Close">
              Abbrechen
            </button>
            <button class="btn btn-primary px-3 shadow ml-2" data-dismiss="modal" aria-label="Close">
              Speichern
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- NAV ON PLANS TODO: FIX ALIGNMENT -->
    <div class="container-fluid">
      <div class="button-areas">
        <div class="row border-bottom pt-2 pb-2">
          <div class="col-xl-6 col-lg-6 col-md-6">
<!--        Button Filter-->
            <button v-if="!opennav.open" type="button"  @click="openNav" v-bind:class="{ active : opennav.open }" class="btn btn-light filter-btn filter-icon-sidebar ml-1">
              <img class="plus-img" src="@/assets/images/img-icons/filter2_black.svg" alt="img">
              <img class="plus-img white" src="@/assets/images/img-icons/filter2_white.svg" alt="image">
              <span class="icons-text-top-bar">Filter</span>
            </button>
            <button v-else type="button"  @click="openNav" :class="{ active : opennav.open }" class="btn btn-light filter-btn ml-1">
              <img class="plus-img white" src="@/assets/images/img-icons/filter2_white.svg" alt="image">
              <span class="icons-text-top-bar">Filter</span>
            </button>

<!--        Button Plan hochladen-->
            <button type="button" v-on:click="openEditTab('bar3-data')"
                    v-bind:class="{ active : is_active_modal }" class="btn btn-light ml-1" data-toggle="modal" data-target=".uploadModal"
                    :disabled="!usercan('editor')">
              <i class="fa-solid fa-arrow-up-from-bracket pr-1"></i>
              <span class="icons-text-top-bar">Plan hochladen</span>
            </button>

<!--        Button Plan herunterladen-->
            <a :href="planPhoto" download>
              <button type="button" class="btn btn-light ml-1">
                <i class="fa-solid fa-download pl-1"></i>
                <span class="icons-text-top-bar">{{ $t('download_plan') }}</span>
              </button>
            </a>
          </div>
          <!--          v-if="is_display_canvas"-->

<!--      Button Bearbeiten-->
          <div v-if="is_display_canvas" class="right-btn col-xl-6 col-lg-6 col-md-6  text-right d-none d-sm-block">
            <button type="button" class="btn btn-light mr-1" v-bind:class="{ active : is_edit || is_edit_active}" v-on:click="onClickEditBtn" id="edit-sidebtn" :disabled="!usercan('editor')">
              <!--                 <img class="plus-img" src="@/assets/images/bpen.png"> -->
              <i class="fa-regular fa-pen-to-square font14"></i>
              <span class="icons-text-top-bar">Bearbeiten</span>
            </button>

          </div>
        </div>
      </div>
    </div>
    <!-- end buttons area -->
    <div id="mySidenav" class="sidenav" :style="{left:opennav.mySidenav}">
      <div class="px-2" id="sidebar">
        <div class="col-12 filter-head mt-2 mb-4">
          <span class="filter-txt"  >{{ $t('filter')  }}</span>
          <button type="button" @click="clearFilter()" class="btn btn-light radius-20 float-right">{{ $t('reset_to_default') }} </button>
        </div>
        <label class="f1 font1rem">{{ $t('search_for') }}:</label>
        <div class="col-12 input-group mb-3 p-0">
          <input class="form-control font12"
                 placeholder="Plannummer, Bezeichnung"
                 data-on-color="success"
                 type="text"
                 name="name"
                 required
                 v-model="searchstring">
        </div>
        <div class="switch">
          <label class="w-100"> {{ $t('active_plans_only') }}
            <input
              type="checkbox"
              v-model="searchStatus"
              class="custom-control-input"
              id="customSwitch1"
            />
            <span class="lever float-right mr-0"></span>
          </label>
        </div>
        <div id="accordion" class="accordion-style mt-2">
          <div class="mb-3"  v-for="(index,i) in tags">
            <div class="" :id="'collapse-left-heading-'+index.id">
              <h5 class="mb-0">
                <a role="button" data-toggle="collapse" :href="'#collapse-left-'+index.id" aria-expanded="true" :aria-controls="'collapse-left-'+index.id">
                  {{index.title}}
                </a>
              </h5>
            </div>
            <div :id="'collapse-left-'+index.id" class="collapse show" :data-parent="'#collapse-left-heading-'+index.id"
                 aria-labelledby="collapse-left-child-heading-1" v-for="(cIndex , ci) in index.childs">
              <div class="" id="collapse-left-child-heading-1"  v-if="cIndex.inputtype==null">
                <h5 class="mb-0">
                  <a role="button" data-toggle="collapse" :href="'#collapse-left1-child-1'+cIndex.id" aria-expanded="true" :aria-controls="'#collapse-left1-child-1'+cIndex.id">
                    {{cIndex.title}}
                  </a>
                </h5>
              </div>
              <div class="custom-control custom-checkbox" :id="'collapse-left1-child-1'+cIndex.id" :data-parent="'collapse-left-'+index.id" v-if="cIndex.inputtype=='Checkbox'">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="cIndex.id"
                  :name="cIndex.title"
                  :value="cIndex.title"
                  v-model="ctags[cIndex.id]"
                  v-on:click="tagsCheckbox(cIndex,$event)"
                />
                <label
                  class="custom-control-label custom-label side_label"
                  :for="cIndex.id"
                >
                  {{cIndex.title}}
                </label>
              </div>
              <div class="form-group ml-2"  :id="'#collapse-left-child-1'+cIndex.id" v-else-if="cIndex.inputtype=='String'">
                <label :for="cIndex.id" class="font-10">{{cIndex.title}}</label>
                <input type="text" :id="cIndex.id"
                  class="form-control-sm sm-input"
                  v-model="ctags[cIndex.id]"
                  placeholder/>
              </div>
              <!--inner loop-->

              <div class="mb-3"  v-for="(iIndex,i) in cIndex.childs">
                <!-- <div class="" id="collapse-left-heading-1">
              <h5 class="mb-0">
                <a role="button" data-toggle="collapse" href="#collapse-left-1" aria-expanded="true" aria-controls="collapse-left-1">
                  {{iIndex.title}}
                </a>
              </h5>
            </div>    -->

                <div :id="'collapse-left-subchild-'+iIndex.id" class="collapse show" data-parent=""
                     aria-labelledby="collapse-left-heading-2" v-for="(ciIndex ,ci) in iIndex.childs">

                  <div class="custom-control custom-checkbox"  v-if="ciIndex.inputtype === 'Checkbox'">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      :id="ciIndex.id"
                      :name="ciIndex.title"
                      :value="ciIndex.title"
                      v-model="ctags[ciIndex.id]"
                      v-on:click="tagsCheckbox(ciIndex,$event)"/>
                    <label
                      class="custom-control-label custom-label"
                      :for="ciIndex.id">
                      {{ciIndex.title}}
                    </label>
                  </div>
                  <div class="form-group ml-2" v-else-if="ciIndex.inputtype=='String'">
                    <label :for="ciIndex.id" class="font-10">{{ciIndex.title}}</label>
                    <input
                      type="text"
                      :id="ciIndex.id"
                      class="form-control-sm sm-input"
                      v-model="ctags[ciIndex.id]"
                      placeholder
                    />
                  </div>

                </div>
                <div class="custom-control custom-checkbox"  v-if="iIndex.inputtype === 'Checkbox'">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    :id="iIndex.id"
                    :name="iIndex.title"
                    :value="iIndex.title"
                    v-model="ctags[iIndex.id]"
                    v-on:click="tagsCheckbox(iIndex,$event)"/>

                  <label class="custom-control-label custom-label" :for="iIndex.id">
                    {{iIndex.title}}
                  </label>
                </div>
                <div class="form-group ml-2" v-else-if="iIndex.inputtype==='String'">
                  <label :for="iIndex.id" class="font-10">{{iIndex.title}}</label>
                  <input
                    type="text"
                    :id="iIndex.id"
                    class="form-control-sm sm-input"
                    v-model="ctags[iIndex.id]"
                    placeholder
                  />
                </div>
              </div>
              <!--inner loop-->

            </div>
          </div>

        </div>

      </div>
    </div>

    <!-- Use any element to open the sidenav -->

    <!-- Add all page content inside this div if you want the side nav to push page content to the right (not used if you only want the sidenav to sit on top of the page -->
    <div id="main" class="pt-0 pb-0 pl-1" :style="{marginLeft:opennav.main}">
      <div class="row">
        <div class="col-lg-3 pr-1 col-md-3 pl-1 col-sm-12 col-xs-12 border-right screen-height">
          <div class="table-responsive">
            <table class="table tble-custom plan_table">
              <thead>
              <tr>
                <th scope="col">Bezeichnung</th>
                <th class="text-center" scope="col">Status</th>
                <th class="text-center" scope="col">GPS</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(plan , index) in all_plans" :key="index" @click="selectPlan(plan.pdplanid,plan)" :class="{ 'active-li' : active_el === plan.pdplanid }">
                <td>
                  <div class="side-h">
                    <h6> {{ plan.description }} </h6><span>{{plan.plannumber}} </span>
                  </div>
                </td>
                <td class="text-center">
                  <img class="img-responsive" v-if="plan.state === '0'" src="@/assets/images/status.png" alt="shap">
                  <img v-else class="img-responsive" src="@/assets/images/deactive.png" alt="shap"/>
                </td>
                <td class="text-center">
                  <img class="img-responsive" v-if="plan.is_georef === '1'" src="@/assets/images/gps.png" alt="shapw">
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- end sidebar -->
        <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12  pr-1 pl-1" id="canvas_box" v-if="is_display_canvas">

          <app-canvas :showPlan="showPlan"
                      :markersList="markersList"
                      :v-bind="counter"
                      :currentEditPin="currentEditPin"
                      :geoRefUpdated="geoRefUpdated"
                      :zoomRange="zoomRange"
                      :is_edit_active="is_edit_active"
                      ref='pointDraw'/>
          <div class="zoom-box" style="padding-left: 6px; padding-right: 6px; -webkit-box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);" >
            <div class="zoom-out">
              <button id="zoom-out" @click="zoomOut">
                <img class="img-responsive" src="@/assets/images/minus.png" style="width: 12px" alt="shap">
              </button>
            </div>
            <div class="zoom-input">
              <input type="range"  v-model="zoomRange" id="zoom-input" min="1" max="2000" step="4" class="slider" >
            </div>
            <div class="zoom-in">
              <button id="zoom-in" @click="zoomIn">
                <img class="img-responsive" src="@/assets/images/plus_c.png" style="width: 12px" alt="shap">
              </button>
            </div>
          </div>
          <div class="edit-box" v-if="is_edit">
            <div class="editbox-text">{{ $t('reference_point') }} :</div>
            <button type="button" @click="pointDraw" class="btn btn-light add_pointer" :disabled="(showPlan.refpoints.length >= 2)">
              {{ $t('add') }}
            </button>
            <button type="button" class="btn btn-light delete_pointer" @click="deleteAllPoints" style="font-size: 13px">
              {{ $t('delete') }}
            </button>
            <span class="ml-3">
              <button type="button" class="btn btn-light mode-d5 btn-danger shadow" @click="changeEditStatus(true);refreshPlanObject(); is_edit = false" style="font-size: 13px">
                {{ $t('cancel') }}
              </button>
              <button type="button" class="btn btn-light mode-d6" style="font-size:14px;" @click="changeEditStatusOnOk" :disabled="!(showPlan.refpoints.length === 0 || showPlan.refpoints.length === 2)">
                Ok
              </button>
            </span>
          </div>

          <div class="edit-box" v-if="is_edit_active">
            <button type="button" @click="drawPointers" class="btn btn-light">
              <img src="@/assets/images/gps.png" class="img-fluid" alt="gps">  GPS Referenzierung
            </button>

            <button type="button"  class="btn btn-light btn-rotate" @click="rotatePlan(-90)" :disabled="!rotate || showPlan.locked == true">
              <i class="fa fa-rotate-backward"></i>
            </button>
            <button type="button"  class="btn btn-light btn-rotate" @click="rotatePlan(90)" :disabled="!rotate || showPlan.locked == true">
              <i class="fa fa-rotate-forward"></i>
            </button>
            <button type="button"  class="btn btn-light btn-rotate" @click="rotatePlan(180)" :disabled="!rotate || showPlan.locked == true">
              <i class="fa fa-refresh"></i>
            </button>
              <button type="button" class="btn btn-light mode-d5" @click="deletePlan" :disabled="showPlan.locked" style="background: red; font-size:14px;z-index: 99">
                <i class="fa fa-trash text-white"></i>
                <span  class="text-light">
                Plan löschen
              </span>
              </button>
          </div>

          <div class="orientation-box" v-if="orientationShow">
            <button type="button" class="btn btn-light m-o"><img src="@/assets/images/gps.png">
              <span> {{ $t('gps_referencing') }}</span>
            </button>
            <button type="button" class="btn btn-light btn-rotate">
              <img class="plus-img" src="@/assets/images/portrait.png" alt="img"></button>
            <button type="button" class="btn btn-light btn-rotate">
              <img class="plus-img" src="@/assets/images/landscape.png" alt="img"> </button>
            <button type="button" class="btn btn-light mode-d5">
              <img src="@/assets/images/trash.png" alt="image"> <span> {{ $t('delete_plan') }}</span> </button>
          </div>

        </div>
        <div class="col-md-6" v-else>
          <div  class="col-md-12">
            <h3 class="pl-4 pt-3">Kein Plan ausgewählt </h3>
          </div>
        </div>
        <!-- end center -->
        <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 pr-0 pl-0">
          <div class="right-sidebar"  v-if="is_display_canvas">
            <!-- display on mobile only -->
            <div class="col-12 d-block d-sm-none">
              <div class="button-areas">
                <div class="row border-bottom">
                  <div class="right-btn col-xl-6 col-lg-6 col-md-6 text-left">
                    <button type="button" class="btn btn-light">
                      <img class="plus-img" src="@/assets/images/download.png" alt="-"> Plan herunterladen   </button>
                    <button type="button" class="btn btn-light ml-2" id="edit-sidebtn2">
                      <img class="plus-img" src="@/assets/images/bpen.png" alt="+">
                      Bearbeiten
                    </button>
                  </div>
                </div>

              </div>
            </div>
            <!-- end -->

            <div class="container sidebar2-head">
              <div class="float-left side2-h w-100"  :class = "(isFilterleftShow) ? 'active' : ''"  v-on:click="openEditTab('bar1-data') ; isFilterleftShow = true;" tabindex="1" id="bar1">
                Eigenschaften
              </div>
<!--              <div class="float-right side2-h" :class = "(isFilterleftShow) ? '' : 'active'"   v-on:click="openEditTab('bar2-data');  isFilterleftShow = false;" tabindex="2" id="bar2">Schlagworte</div>-->
            </div>
            <ul class="sidebar2-li pb-4" v-if="!is_edit && !is_edit_active" id="bar1-data">
              <li>
                <h6>
                  <!--                                       {{ $t('ground_floor') }}-->
                  Bezeichnung
                </h6>
                <span>{{showPlan.description}}</span>
              </li>
              <li>
                <h6>    {{ $t('number') }}</h6>
                <span>{{showPlan.plannumber}}</span>
              </li>
              <li>
                <h6>    {{ $t('revision') }}</h6>
                <span>{{showPlan.revision}}</span>
              </li>
              <li>
                <h6>    {{ $t('file_name') }}</h6>
                <span>{{showPlan.origname}}</span>
              </li>
              <li>
                <h6>  {{ $t('upload_on') }}</h6>
                <span>{{ dateFormat(showPlan.created) }}</span>
              </li>
              <li>
                <h6>  {{ $t('expiry_data') }} </h6>
                <span>{{ dateFormat(showPlan.expirationdate) }}</span>
              </li>
              <li>
                <h6> {{ $t('predecessor') }} </h6>
                <span v-for="item in plansForDropDown" v-if="item.pdplanid === editPlan.predecessorid">
                  {{item.description}}
                </span>
              </li>
              <li>
                <h6 class="mb-1">{{ $t('status') }}</h6>
                <div class="clearfix">
                  <div class="float-left">
                    <input class="radio-side green bg-success"
                      v-model="showPlan.state"
                      type="radio"
                      name="status"
                      disabled="disabled"
                      value="0"/>
                    <label for="Aktiviert" class="side-lable pl-1">{{ $t('activated') }}</label>
                  </div>
                  <div class="">
                    <input
                      class="radio-side ml-2"
                      v-model="showPlan.state"
                      type="radio"
                      disabled="disabled"
                      name="status"
                      id="Aktiviert"
                      value="1"/>
                    <label class="side-lable pl-1" >{{ $t('disabled') }}</label>
                  </div>
                </div>
              </li>
              <li>
                <h6 class="mb-1"> {{ $t('marking_color') }}</h6>
                <div class="colors">
                  <label>
                    <input
                      type="radio"
                      name="color"
                      v-model="editPlan.color"
                      disabled
                      value="9CB55D"/>
                    <span class="swatch" style="background: #9CB55D"></span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="color"
                      v-model="editPlan.color"
                      disabled
                      value="5d70b5"/>
                    <span class="swatch" style="background: #5d70b5"></span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="color"
                      v-model="editPlan.color"
                      disabled
                      value="b55d9c"/>
                    <span class="swatch" style="background: #b55d9c"></span>
                  </label>

                  <label>
                    <input
                      type="radio"
                      name="color"
                      v-model="editPlan.color"
                      disabled
                      value="ff0000"/>
                    <span class="swatch" style="background: #ff0000"></span>
                  </label>

                  <label>
                    <input type="radio" v-model="editPlan.color" name="color" disabled value="FFdd00"/>
                    <span class="swatch" style="background: #FFdd00"></span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="color"
                      disabled
                      v-model="editPlan.color"
                      value="FF9900"/>
                    <span class="swatch" style="background: #FF9900">
                        </span>
                  </label>
                </div>
              </li>
              <li>
                <h6 class="mb-2"> {{ $t('other_information') }} </h6>
                <div id="other-info p-2" class="card p-1">
                  {{showPlan.extrainfo}}
                </div>
              </li>
            </ul>
            <!-- Second Bar -->

            <!-- Second Edit SideBar -->
            <div class="edit-sidebar sidebar2-li"  v-if="is_edit_active || is_edit">
              <form  @submit.prevent="savePlan(); cancelEdit()">
                <ul>
                  <li>
                    <div class="form-group">
                      <label>
                        Bezeichnung
                      </label>
                      <input
                        class="input--style-2 form-control input-style"
                        value="Erdgeschoss"
                        type="text"
                        v-model="editPlan.description"
                        required>
                    </div>
                  </li>
                  <li>
                    <div class="form-group">
                      <label>{{ $t('number') }}</label>
                      <input
                        class="input--style-2 form-control input-style"
                        value="5-KB_TB_C123"
                        type="text"
                        v-model="editPlan.plannumber"
                        required>
                    </div>
                  </li>
                  <li>
                    <div class="form-group">
                      <label>{{ $t('revision') }}</label>
                      <input class="input--style-2 form-control input-style" value="0" type="text" v-model="editPlan.revision">
                    </div>
                  </li>
                  <li>
                    <div class="form-group">
                      <label>{{ $t('file_name') }}</label>
                      <input class="input--style-2 form-control input-style"
                        type="text"
                        required
                        readonly
                        :value="editPlan.origname">
                    </div>
                  </li>
                  <li>
                    <div class="form-group">
                      <label for="datepicker4">{{ $t('upload_on') }}</label>
                      <input class="input--style-2 form-control input-style"  readonly :value="dateFormat(editPlan.created)" id="datepicker4">
                    </div>
                  </li>
                  <li>
                    <div class="form-group">
                      <label for="datepicker3">{{ $t('expiry_data') }}</label>
                      <input class="input--style-2 form-control input-style" id="datepicker3" :value="setDate(editPlan.expirationdate)" data-date-format="dd.mm.yyyy">
                    </div>
                  </li>
                  <li>
                    <div class="form-group">
                      <label for="predecessors">{{ $t('predecessor') }}</label>
                      <select class="input-style w-100" id="predecessors" v-model="editPlan.predecessorid">
                        <option v-for="pln in plansForDropDown" :key="pln.runid" :value="pln.pdplanid" v-if="editPlan.pdplanid != pln.pdplanid">
                          {{pln.description}}
                        </option>
                      </select>
                    </div>
                  </li>
                  <li>
                    <h6 class="mb-1">{{ $t('status') }}</h6>
                    <div class="clearfix">
                      <div class="float-left mr-2">
                        <input
                          class="radio-side"
                          v-model="editPlan.state"
                          type="radio"
                          name="status"
                          value="0"
                          id="Aktiviert1"/>
                        <label for="Aktiviert1" class="side-lable font1rem pl-1">{{ $t('activated') }}</label>
                      </div>
                      <div class="">
                        <input class="radio-side"
                          type="radio"
                          name="status"
                          value="1"
                          v-model="editPlan.state"
                          id="Deaktiviert1"/>
                        <label for="Deaktiviert1" class="side-lable font1rem pl-1">{{ $t('disabled') }}</label>
                      </div>
                    </div>
                  </li>
                  <li>
                    <h6>{{ $t('marking_color') }}</h6>
                    <div class="colors">
                      <label>
                        <input
                          type="radio"
                          name="color"
                          v-model="editPlan.color"
                          value="9CB55D"/>
                        <span class="swatch" style="background: #9CB55D"></span>
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="color"
                          v-model="editPlan.color"
                          value="5d70b5"/>
                        <span class="swatch" style="background: #5d70b5"></span>
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="color"
                          v-model="editPlan.color"
                          value="b55d9c"/>
                        <span class="swatch" style="background: #b55d9c"></span>
                      </label>

                      <label>
                        <input
                          type="radio"
                          name="color"
                          v-model="editPlan.color"
                          value="ff0000"/>
                        <span class="swatch" style="background: #ff0000"></span>
                      </label>

                      <label>
                        <input type="radio" v-model="editPlan.color" name="color" value="FFdd00"/>
                        <span class="swatch" style="background: #FFdd00"></span>
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="color"
                          v-model="editPlan.color"
                          value="FF9900"/>
                        <span class="swatch" style="background: #FF9900">
                        </span>
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="form-group">
                      <label for="other-info2">   {{ $t('other_information') }}</label>
                      <textarea id="other-info2" class="form-control" v-model="editPlan.extrainfo" rows="4"></textarea>
                    </div>

                  </li>
                </ul>
                <div class="sticky-btns pb-1">
                  <button type="button" class="btn btn-danger" @click="changeEditStatus(true); is_edit = false"> {{ $t('cancel') }}</button>
                  <button type="submit" class="btn btn-primary">{{ $t('save') }}</button>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="response-alert">
      <div class="alert alert-success alert-dismissible" v-for="m in msg">
        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
        <strong></strong>
        {{m}}
      </div>
      <div class="alert alert-danger alert-dismissible" v-for="e in error">
        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
        <strong></strong>
        {{e}}
      </div>
    </div>

    <div class="modal fade uploadModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content col-6" style="margin: 0 auto;">
          <div class="modal-body upload-body">
            <div class="upload-full">
              <div class="float-left upload-lf">Pläne hochladen</div>
              <div class="float-right"> <button type="button" class="close" data-dismiss="modal" @click="is_active_modal=false" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              </div>
            </div>
            <div class="uploadOuter">
              <!--  <label for="uploadFile" class="btn btn-primary">Upload Image</label>
                      <strong>OR</strong> -->
              <span class="dragBox" >
                <div class="drag-t">Drag & Drop</div>
                <span class="drag-h">Ziehen Sie Ihre Dateien in diesen Bereich</span>
                <button type="button" class="btn btn-light mode-uploadbtn"> Datei hochladen </button>
                <input type="file" class="d-input" @change="dragNdrop"  ondragover="drag()" ondrop="drop()" id="uploadFile" multiple="multiple" accept=".jpg,.jpeg,.pdf" />
              </span>
            </div>
            <span class="upload-status">Upload Status</span><span class="state-num">{{uploadPercentage}}</span>
            <div class="progress progbar-st">
              <div class="progress-bar custom-bar" role="progressbar" :style="{width:uploadPercentage}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div id="preview" class="d-flex align-content-start flex-wrap"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from '../../utils/axiosinstance'
// import axios from 'axios'
import MyCanvas from './Canvas.vue'
import {formatAsInputDate, formatDate} from '../common'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    //key: 'AIzaSyC-cOnw6mOonw8UvaueMal6oVsrBHUefXY',
    key: 'AIzaSyAOAi65H1XRaqGzf7fXaavOPa9ncvNTWL4',
    //for local testing
    //key: 'AIzaSyAFxSpy5vf23BRuBWTZIyEckCvNktSnsHc',
    libraries: 'places'
  }
})
export default {
  name: 'HelloWorld',

  data () {
    return {
      searchstring: '',
      map_type: 'roadmap',
      prevLatLng: {},
      counter: 0,
      is_display_canvas: false,
      rotate: true,
      uploadPercentage: '0%',
      submitted: false,
      fexpand: false,
      editShowtab: false,
      searchStatus: true,
      currentSrc: '',
      searchDateFrom: '',
      searchDateTo: '',
      planImg : '',
      isSearchDate: 0,
      active_el: 1,
      markersList: [{'position': {lat: 51.420250, lng: 6.835990 }, 'coadinates': {x: 0, y: 0}}],
      geoRefUpdated: [],
      mapClicks: [],
      is_edit_active: false,
      mapCentre: {lat: 51.420250, lng: 6.835990},
      mapLatLong: {lat: 51.420250, lng: 6.835990},
      refpoints: {
        'x': 1280.6,
        'y': -154.85,
        'lat': 51.420250,
        'lon': 6.835990
      },

      plans: [
        {
          id: '',
          project_id: '',
          orig_filename: '',
          hash: ' ',
          planname: ' ',
          plannumber: ' ',
          planrevision: ' ',
          plandescription: ' ',
          plandate: ' ',
          planexpirationdate: ' ',
          planpredecessorid: null,
          defaultpincolor: '',
          is_georef: '',
          refpoints: null,
          runid: '',
          status: '',
          deleted: '',
          creator_id: '',
          lastupdated: ' ',
          cr_date: ' ',
          ch_date: ' ',
          src: ''
        }
      ],
      plans1: [
        {
          id: '',
          project_id: '',
          orig_filename: '',
          hash: ' ',
          planname: ' ',
          plannumber: ' ',
          planrevision: ' ',
          plandescription: ' ',
          plandate: ' ',
          planexpirationdate: ' ',
          planpredecessorid: null,
          defaultpincolor: '',
          is_georef: 0,
          refpoints: null,
          runid: '',
          status: '',
          deleted: '',
          creator_id: '',
          lastupdated: ' ',
          cr_date: ' ',
          ch_date: ' ',
          src: ''
        }
      ],
      editPlan: {},

      showPlan: {
        id: '41',
        project_id: '192',
        orig_filename: 'Süd-West_Außenperspektiven Stand 2012-06-14_V1.0.pdf',
        hash: 'a314381b48aa69bc64f432de2565e4f7',
        planname: 'Süd-West 3D',
        plannumber: 'Süd-West_Außenperspektiven  ',
        planrevision: 'C',
        plandescription: 'n/a',
        plandate: '2020-01-20',
        planexpirationdate: '2020-02-25',
        planpredecessorid: null,
        defaultpincolor: '#330000',
        is_georef: '0',
        refpoints: null,
        runid: '4',
        status: '0',
        deleted: '0',
        creator_id: '53',
        lastupdated: '2020-04-20 18:00:00',
        cr_date: '2020-04-20 18:00:00',
        ch_date: '2020-04-20 18:00:00',
        src: require('@/assets/images/map.png')
      },

      filterparams: {
        searchstring: '',
        validdate_from: '',
        validdate_to: '',
        tags: []
      },
      order: {
        '<fieldname>': '',
        '<fieldname2>': ''
      },
      tags: [],
      msg: [],
      error: [],
      ctags: [],
      tagskeys: [],
      filtertTags: [],
      opennav: {
        open: 0,
        mySidenav: -215,
        main: 0
      },
      mapPosition: {lat: 0, lng: 0},
      editTabShow: 0,
      is_edit: false,
      is_active_modal: false,
      orientationShow: 0,
      zoomRange: 0,
      lastZoom: 0,
      currentEditPin: '',
      currentPlanId: 0,
      toBeDeletedPins: [],
      isFilterleftShow: 1,

      planCopy: {}
    }
  },
  components: {
    appCanvas: MyCanvas
  },
  validations: {},
  created () {
    this.getPlans();
  },
  mounted () {
    $('.uploadModal').on('hide.bs.modal', function () {
      $('.btn-modal').removeClass('active')
    })
    $('.uploadModal').on('show.bs.modal', function () {
      $('.btn-modal').addClass('active')
    })

    var fexpand = false

    $('#datepicker,#datepicker1').datepicker({
      autoclose: true,
      format: 'DD.MM.YYYY',
      todayHighlight: true
    }).datepicker('update', new Date())
    $('#datepicker4').datepicker().change(function () {
      $('#datepicker3').datepicker('option', 'maxDate', $(this).datepicker('getDate'))
    })
    $('#datepicker,#datepicker1').change(function () {
      $(this)[0].dispatchEvent(new Event('input'))
    })

    $('#filter-btn').click(function () {
      if (!fexpand) {
        $('.filter-box').css('display', 'block')
        $('.left-sidebar').addClass('sidebar-fl')

        fexpand = true
      } else {
        $('.filter-box').css('display', 'none')
        $('.left-sidebar').removeClass('sidebar-fl')
        fexpand = false
      }
    })
  },
  destroyed () {
    /** When close Site Enable Scroll for other Sites **/
    let elHtml = document.getElementsByTagName('html')[0]
    elHtml.style.overflowY = 'auto'

    /** When close Site Enable Scroll for other Sites END **/
  },

  methods: {
    updateCoordinates(location) {
      this.mapLatLong = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
    },

    updatePointerCoordinates(location) {
      this.mapCentre = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
      this.$refs.pointDraw.mapLat = this.mapCentre.lat
      this.$refs.pointDraw.mapLng = this.mapCentre.lng
    },


    autoCompletePlaceChanged(location){
        const place = location;
        let lat = place.geometry.location.lat();
        let lng = place.geometry.location.lng();
        this.mapCentre = {lat, lng};
      this.$refs.pointDraw.mapLat = lat
      this.$refs.pointDraw.mapLng = lng
    },

    deletePointer () {
      this.$refs.pointDraw.deletePointer()
    },

    async deletePlan () {

      let planId = this.showPlan.pdplanid
      let _this = this
      this.$confirm({
        message: "Plan löschen?",
        button: {
          no: 'Abbrechen',
          yes: 'Ja'
        }, callback: confirm => {
          if (confirm) {
            $('.spinner-cover').show()
            _this.$store.dispatch('deletePlanImage',planId)
            _this.getPlans()
            _this.is_display_canvas = false
            $('.spinner-cover').hide()
          }
        }
      });
    },

    pointDraw: function () {
      this.$refs.pointDraw.setPonter(false);
    },

    tagsCheckbox: function (index, event) {
      let temp = {stype: 'OR', keys: []}

      this.tagskeys[index.id] = event.target.checked

      this.tagskeys.forEach(function (value, i) {
        let ii = {}
        ii[i] = '1'
        if (value) { temp.keys.push(ii) }
      })
      if (temp.keys.length > 0) { this.filterparams.tags = [temp] } else { this.filterparams.tags = [] }

      this.getPlans()
    },

    mark (event) {
      let position = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng()
      }
      this.mapPosition = position
      this.markersList[0].position = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng()
      }
      this.mapClicks.push(position)
    },

    showMaps () {
      let lat = $('#pointer-box1').val()
      let lon = $('#pointer-box2').val()
      window.open('https://dev2021frontend.projectdocu.net/checkcoordinates.php?typ=pdportal&lat=' + lat + '&lon=' + lon, '_blank', 'width=1920,height=900')
      this.fexpand = !this.fexpand;
    },


    //get all plans api call
    async getPlans (plain_id = null) {
      const id = this.$route.params.id
      await this.$store.dispatch('getAllPlans', id)
      if (plain_id === null){
        let plan = this.all_plans[0]
        await this.selectPlan(plan.pdplanid,plan)
      }
    },
    setDate(date){
      return formatDate(date)
    },

    setDatePicker () {
      let _this = this
      $('#datepicker3').datepicker({
        autoclose: true,
        todayHighlight: true,
      }).on('changeDate', function(ev){
        console.log("here ia m")
          _this.editPlan.expirationdate = formatAsInputDate(ev.target.value);
      });
    },

    async savePoint (tab, data) {
      this.geoRefUpdated = data
      this.editPlan.refpoints = data
     await this.savePlan()
    },


    //Update Plan Information
    async savePlan (is_api = true) {
      let loading = $('.spinner-cover');
      let plan = this.editPlan;
      plan.refpoints = this.showPlan.refpoints
      delete plan.src;
      if (plan.refpoints.length >= 2 ){
        let def = this.getNorthDifference(plan.refpoints);
        plan.north_deviation_angle = Math.floor(def)
        plan.is_georef = 1
      }else {
        plan.is_georef = 0
      }
      let params = [plan.pdplanid, plan]
      loading.show()
      await  this.$store.dispatch('updatePlan',params)
      this.onClickEditBtn()
      loading.hide();
      await this.getPlans(plan.pdplanid);
    },


    cancelEdit () {
      this.is_edit = this.is_edit === false
      if (!this.is_edit) {
        this.changeEditStatus(true)
      }
    },

    changeEditStatus (is_cancel = false) {
      this.is_edit_active = !is_cancel
      const _this = this
      if (this.is_edit){
        this.editTabShow = this.is_edit = this.is_edit_active = true
      }else {
        this.editTabShow = false
      }
      if (is_cancel){
        this.$refs.pointDraw.pointBox = false
        this.$refs.pointDraw.removeAllPoints();
      }
      setTimeout(function (){_this.setDatePicker()},200)
    },

    onClickEditBtn(){
      const _this = this
      if (this.is_edit || this.is_edit_active){
        this.is_edit = this.is_edit_active = this.$refs.pointDraw.pointBox = false
        this.$refs.pointDraw.removeAllPoints();
      }else {
        this.is_edit = false
        this.is_edit_active = true
      }
      setTimeout(function (){_this.setDatePicker()},200)
    },


    async changeEditStatusOnOk () {
      this.editTabShow = this.is_edit_active = true
      this.is_edit = false
      await this.$refs.pointDraw.removeAllPoints();
    },

    openEditTab (dataName) {
      // $('#bar1-data').hide();
      $('#bar2-data').hide();
      $('#bar3-data').hide();
      if (this.editTabShow) {
        if (dataName == 'bar1-data') {
          $('#bar3-data').show()
        }
        if (dataName == 'bar2-data') {
          $('#bar2-data').show()
        }
      } else {
        if (dataName == 'bar2-data') {
          $('#bar2-data').show()
        }
        if (dataName == 'bar3-data') {
          this.is_active_modal = true
          $('#bar3-data').show()
        }
        if (dataName === 'bar1-data') {
          $('#bar1-data').show()
        }
      }
    },


    //Get and upload files on select / drop
    async dragNdrop (e) {
      let files = e.target.files;
      for ( let i = 0; i < files.length; i++ ){
        let id = Math.floor(Math.random() * 99999999)
        await  this.uploadFile(files[i],id);
      }
      $('.uploadModal').modal('toggle');
    },


    /**Upload Plan File
     *
     * @param file
     * @param progressID
     * @returns {Promise<void>}
     */
    async uploadFile (file, progressID) {
      $('.spinner-cover').show();
      let _this = this
      let  formData = new FormData()
      formData.append('Upload',file);
      let url = `${process.env.VUE_APP_BASE_URL}backend/put?token=${localStorage.sessiontoken}&method=plan&projectid=${this.$route.params.id}`
      await axios.post(url, formData,{
        onUploadProgress: function (progressEvent) {
          _this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100)) + '%'
          $('#' + progressID).css('width', parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100)) + '%')
        }
      }).then(response => {
        console.log(response,"response is here");
        if (response.status === 200 || response.statusText === '200'){
          $('.spinner-cover').hide();
          _this.getPlans();
          _this.uploadPercentage = 0;
          _this.$toast.success("Plan hochgeladen");
        }
      }).catch(e => {
        $('.spinner-cover').hide()
        this.error.push(e)
      })
    },


    clearFilter () {
      this.searchStatus = 1
      this.searchDateFrom = ''
      this.searchDateTo = ''
      this.isSearchDate = 0
      this.filterparams.searchstring = ''
      this.filterparams.tags = []
      this.ctags = []
      this.getPlans()
    },


    // method plan image set
    async  selectPlan (planId = false,plan) {
      this.$store.commit('togglePlainLoading',true)
      plan.color = plan.color ? plan.color : "#ff0000"
      this.showPlan = plan;
      this.rotate = plan.refpoints.length === 0
      this.editPlan = plan
      this.planCopy = {...plan};
      this.zoomRange = 0
      this.editShowtab = false
      this.is_edit_active = false
      this.is_edit = false
     await this.$store.dispatch('getPlanImageFile',planId)
      this.is_display_canvas = true
      this.active_el = planId
      this.$store.commit('togglePlainLoading',false)
    },

    dateFormatDashes (val) {
      let split = val.split('.')
      return split[1] + '-' + split[0] + '-' + split[2]
    },


    async drawPointers () {
      await this.$refs.pointDraw.removeAllPoints()
      this.is_edit = this.editTabShow = this.editShowtab = true
      this.is_edit_active = false
      await this.$refs.pointDraw.drawPonter(this.showPlan)
    },

    async refreshPlanObject () {
      await this.$refs.pointDraw.removeAllPoints();
      let points = this.planCopy
      this.showPlan.refpoints = JSON.parse(points.refpointsjson)
    },

    //delete all points from object as well
   async deleteAllPoints () {
      await this.$refs.pointDraw.removeAllPoints();
      this.showPlan.refpoints = []
    },

    openNav (event) {
      if (!this.opennav.open) {
        this.opennav.open = 1
        this.opennav.mySidenav = '0'
        this.opennav.main = '210px'
      } else {
        this.opennav.open = 0
        this.opennav.mySidenav = '-225px'
        this.opennav.main = '0'
      }
    },

    //Set date format to german
    dateFormat: (date) => formatDate(date),

    zoomIn () {
      if (this.zoomRange < 2000) {
        this.zoomRange = (parseInt(this.zoomRange)) + (4)
      }
    },

    zoomOut () {
      if (this.zoomRange > 0) {
        this.zoomRange = (parseInt(this.zoomRange)) - (4)
      }
    },

   async rotatePlan(degree){
     $('.spinner-cover').show()
      let planId = this.showPlan.pdplanid
      let payload = [planId , degree]
     await this.$store.dispatch('rotatePlanImage', payload)
     await this.$store.dispatch('getPlanImageFile',planId)
     this.$toast.success('Plan gedreht')
     $('.spinner-cover').hide()
    },



  getNorthDifference (refPoints) {

    let refPointP1 = refPoints[0];
    let refPointP2 = refPoints[1];

    let distanceMap = Math.sqrt(Math.pow(refPointP2.x - refPointP1.x, 2) +Math.pow(refPointP1.y - refPointP2.y, 2));

    let distanceGeo = Math.sqrt(Math.pow((refPointP2.lat - refPointP1.lat) * 111, 2) +Math.pow((refPointP2.lon - refPointP1.lon) * 111 * Math.cos(Math.PI * (refPointP1.lat + refPointP2.lat) / 360), 2));

    let distanceMultiply = distanceMap / distanceGeo;

    let angleMap = this.getAngle((refPointP2.x - refPointP1.x), (refPointP1.y - refPointP2.y));

    let angleGeo = this.getAngle(((refPointP2.lon - refPointP1.lon) * Math.cos(Math.PI * (refPointP1.lat + refPointP2.lat) / 360)), (refPointP2.lat - refPointP1.lat));

    let angleDifference = angleMap - angleGeo;

    return (angleDifference * (180 / Math.PI))
  },


   getAngle(dx, dy) {
      if (dx > 0) {
        return Math.atan(dy / dx);
      }
      else if ( dx < 0 && dy >= 0 ) {
        return Math.atan(dy / dx) + Math.PI;

      }else if (dx < 0 && dy < 0) {
        return Math.atan(dy / dx) - Math.PI;

      }else if (dx === 0 && dy > 0) {
        return Math.PI;

      }else if (dx === 0 && dy < 0) {
        return -1 * Math.PI;

      }else if (dx === 0 && dy === 0) {
        return 0;
      }
     return Math.atan2(dy, dx);
    },

    resetLatLng(){
      this.mapCentre = {...this.prevLatLng}
      this.mapLatLong = {...this.prevLatLng}
    }
  },
  computed: {
    planPhoto: function (){
      return this.$store.state.plans.planImage
    },
    all_plans () {
      if (this.searchstring.length){
         return this.$store.state.plans.allPlans.filter(item => {
         return  item.description.toLowerCase().includes(this.searchstring.toLowerCase()) || item.runid.includes(this.searchstring)
        })
      }
      if (this.searchStatus){
        return  this.$store.state.plans.allPlans.filter(item => item.state === '0')
      }
      else {
        return  this.$store.state.plans.allPlans
      }
    },
    plansForDropDown(){
      return  this.$store.state.plans.allPlans
    },
    isLoading(){
      return  this.$store.state.plans.plainLoading
    }
  },

  watch: {
    '$route.params' () {
      window.location.reload()
    },
    zoomRange: function (zoomRange) {
      if (this.$refs.pointDraw) {
        this.$refs.pointDraw.zoomIn(zoomRange)
      }
    },
    showPlan: function (showPlan) {
      this.currentSrc = showPlan.src
    },
    ctags: function (val) {

    },
    modal3: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    },
    msg: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 4000)
    },
    emodal3: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    },
    error: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    }
  },
  filters: {
    'date': function (date) {
      var newDay = new Date(date),
        currentDate = ('0' + newDay.getDate()).slice(-2),
        currentMonth = ('0' + (newDay.getMonth() + 1)).slice(-2),
        currentYear = newDay.getFullYear()

      var day = ''
      day = currentDate + '.' + currentMonth + '.' + currentYear
      return day
    },
    'dateTime': function (date) {
      const newDay = new Date(date),
        currentDate = ('0' + newDay.getDate()).slice(-2),
        currentMonth = ('0' + (newDay.getMonth() + 1)).slice(-2),
        currentYear = newDay.getFullYear()

      let day = ''
      day = currentDate + '.' + currentMonth + '.' + currentYear + ' ' + newDay.getHours() + ':' + newDay.getMinutes()
      return day
    }
  }
}
</script>

<style scoped>
.active{
  background-color: #39F !important;
  color: #ffffff !important;
}
.table td{
  padding: 0.5rem 0 !important;
}
.search-box{
  z-index: 99;
}
.btn-light.mode-d5:disabled:hover{
  background: #a35252 !important;
  cursor: not-allowed;
}
.btn-light.btn-rotate:disabled:hover{
  cursor: not-allowed;
  background: rgba(246, 229, 229, 0.76) !important;
}
.btn-map{
  color: #151414;
}
</style>
<style>
button.gm-fullscreen-control{
  display: none !important;
}
.pac-container {
  z-index: 999999 !important;
}

.g-map-container{
  margin-top: -45px;
}
div.gmnoprint{
  left: auto !important;
  right: 31px !important;
}
.gm-style .gm-style-iw-c{
  min-width: 14rem;
}
.sticky-btns{
  width: 100%;
  padding-top: 2px;
  padding-bottom: 1px;
  position: sticky;
  text-align: center;
  bottom: 0;
  background-color: #ffffff8c;
  border-top: 1px solid #00000069;
}
.sticky-btns button.btn{
  line-height: 1.8;
  font-size: 11px;
  font-weight: 500;
  padding: 1px 6px;
}
.gm-svpc{
  display: none !important;
}
.s-c-btns button{
  line-height: 2.5;
}
.switch-map{
  position: absolute;
  top: 7px;
  right: 25px;
  z-index: 9999;
  background: white;
  color: #151414;
}
.gmnoprint .gm-style-mtc{
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/plan/plan.vue